module.exports = "/remote-dist/21e5f1fa6dafaae480cbde87bfd233ae.png";